import { BroadcastChannel, createLeaderElection } from 'broadcast-channel';
export const requestTabLeadership = () => {
    const electionChannel = new BroadcastChannel('streem', { webWorkerSupport: false });
    const election = createLeaderElection(electionChannel);
    return election.awaitLeadership();
};
//# sourceMappingURL=active_tab_election.js.map